/**
 * Black-Swan Event Bus
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 *
 * @update: 2020-06-25 TAMS 전역 이벤트 허브 (default.vue destroy 까지 이벤트 유지용)
 */

import Vue from 'vue'

const Bus = new Vue({
  data: {
    eventBusQueue: [],
    timerBox: {},
    defaultOptions: {
      start: _.noop(),
      stop: _.noop()
    }
  },
  methods: {
    addTimer (timerName, options) {
      try {
        if (typeof this.timerBox[timerName] !== 'undefined') {
          return
        }
        if (typeof options !== 'object') {
          return
        }

        const pickOptions = _.pick(options, ['start', 'stop'])
        let mergeOptions = _.merge(this.defaultOptions, pickOptions)
        mergeOptions.name = timerName

        this.timerBox[timerName] = mergeOptions
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (addTimer)]'], e)
      }
    },
    removeTimer (timerName) {
      try {
        if (typeof this.timerBox[timerName] !== 'undefined') {
          return
        }
        if (typeof this.timerBox[timerName].stop === 'function') {
          this.timerBox[timerName].stop.apply()
        }

        delete this.timerBox[timerName]
        this.timerBox = _.filter(this.timerBox, timer => timerName !== timer.name)
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (removeTimer)]'], e)
      }
    },
    startTimer (timerName, params) {
      try {
        if (typeof this.timerBox[timerName] !== 'undefined') {
          return
        }
        this.timerBox[timerName].start.apply(params)
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (startTimer)]'], e)
      }
    },
    endTimer (timerName, params) {
      try {
        if (typeof this.timerBox[timerName] !== 'undefined') {
          return
        }
        this.timerBox[timerName].stop.apply(params)
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (endTimer)]'], e)
      }
    },
    startAllTimer () {
      try {
        const timers = _.keys(this.timerBox)
        if (_.size(timers) > 0) {
          _.forEach(timers, timer => {
            this.timerBox[timer].start.apply()
          })
        }
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (startAllTimer)]'], e)
      }
    },
    stopAllTimer () {
      try {
        const timers = _.keys(this.timerBox)
        if (_.size(timers) > 0) {
          _.forEach(timers, timer => {
            this.timerBox[timer].stop.apply()
          })
        }
      } catch (e) {
        window.$nuxt.$log(['Global Event Hub Error (stopAllTimer)]'], e)
      }
    },
    /*
      이름 : addEventBus
      설명 : EventBus를 생성하고 연결합니다. 이벤트 이름은 내부 모델인 eventBusQueue에서 관리합니다.
    */
    addEventBus (eventName, callbackFunc) {
      this.$on(eventName, callbackFunc)
      this.eventBusQueue.push(eventName)
    },
    /*
      이름 : removeEventBus
      설명 : 파라미터로 전달된 이름을 가지는 이벤트를 제거합니다.
    */
    removeEventBus (eventName) {
      this.$off(eventName)
      this.eventBusQueue = this.eventBusQueue.filter(value => value !== eventName)
    },
    /*
      이름 : removeAllEventBus
      설명 : 등록된 모든 이벤트를 제거합니다.
    */
    removeAllEventBus () {
      for (const eventBus of this.eventBusQueue) {
        this.$off(eventBus)
      }
      this.eventBusQueue = []
    }
  }
})

export default Bus
